"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _panel = _interopRequireDefault(require("../panel"));

var _Visibility = _interopRequireDefault(require("./Visibility"));

var _Indicator = _interopRequireDefault(require("./Indicator"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var ConfigurationPanel = function ConfigurationPanel(props) {
  var _props$configuration = props.configuration,
      defaultMessage = _props$configuration.defaultMessage,
      successMessage = _props$configuration.successMessage,
      visibility = _props$configuration.visibility,
      indicator = _props$configuration.indicator,
      indicatorLabel = _props$configuration.indicatorLabel;
  return (0, _preact.h)(_panel.default, {
    title: "Configuration"
  }, (0, _preact.h)("div", {
    className: "row"
  }, (0, _preact.h)(_InputGroup.default, {
    id: "default-message-when-not-voted",
    title: "Default message",
    meta: "The message users get to see when they did not vote yet",
    type: "text",
    onChange: function onChange(e) {
      return props.setValue(e.target.value, 'defaultMessage');
    },
    value: defaultMessage
  }), (0, _preact.h)(_InputGroup.default, {
    id: "thank-you-message-when-voted",
    title: "Thank you message",
    meta: "The message users get to see after they voted",
    type: "text",
    onChange: function onChange(e) {
      return props.setValue(e.target.value, 'successMessage');
    },
    value: successMessage
  })), (0, _preact.h)(_Indicator.default, {
    status: indicator,
    setIndicator: props.setIndicator,
    indicatorLabel: indicatorLabel,
    setIndicatorLabel: props.updatePhrase
  }), (0, _preact.h)(_Visibility.default, {
    visibility: visibility,
    onChange: function onChange(visibility) {
      return props.setVisibility(visibility);
    }
  }));
};

var _default = ConfigurationPanel;
exports.default = _default;